/*
 * Training tools page (sections/zodiac-training-tools.liquid).
 *
 * 1. The hero stamp steps through V2 to V6 for a 154 lbs climber. Held on V6
 *    for prefers-reduced-motion.
 * 2. The calculator: a second copy of snippets/finger-strength-calc.liquid. It keeps
 *    that snippet's ids and data attributes, so assets/posthog.js (bindFingerCalc)
 *    sends Calculator Viewed / Calculated / Unit Changed from here too, and this file
 *    sends Calculator Feedback with the snippet's exact payload. A "no" vote then
 *    asks what they climb and sends Calculator Grade Reported.
 *
 *    BANDS must match the snippet. Change both or neither.
 *
 *    The card recalculates as you type, so the grade is written after a pause.
 *    posthog.js sends Calculated whenever #zc-grade changes to a new grade, and a
 *    per-keystroke write would count half-typed numbers.
 */
(function () {
  'use strict';

  /* ---------- hero stamp ---------- */
  (function stamp() {
    var root = document.querySelector('[data-ztt-stamp]');
    if (!root) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var BW = 154;
    var STEPS = [['V2', 48], ['V3', 54], ['V4', 77], ['V5', 92], ['V6', 95]];
    var pct = root.querySelector('[data-ztt-pct]');
    var lift = root.querySelector('[data-ztt-lift]');
    var grades = root.querySelectorAll('[data-ztt-grade]');
    var marks = root.querySelectorAll('[data-ztt-step]');
    var i = 0;

    function paint(n) {
      var s = STEPS[n];
      pct.textContent = Math.round(s[1] / BW * 100);
      lift.textContent = s[1];
      for (var g = 0; g < grades.length; g++) grades[g].textContent = s[0];
      for (var m = 0; m < marks.length; m++) {
        marks[m].classList.toggle('is-on', m <= n);
        marks[m].classList.toggle('is-now', m === n);
      }
    }

    paint(0);
    var timer = setInterval(function () {
      if (document.hidden) return;
      root.classList.add('is-flipping');
      setTimeout(function () {
        i = (i + 1) % STEPS.length;
        paint(i);
        root.classList.remove('is-flipping');
      }, 250);
    }, 2500);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
  })();

  /* ---------- calculator ---------- */
  (function calc() {
    var root = document.getElementById('zCalc');
    if (!root || root.dataset.zcReady) return;
    root.dataset.zcReady = '1';

    var BANDS = [
      { max: 0.14, grade: 'V0' }, { max: 0.29, grade: 'V1' }, { max: 0.33, grade: 'V2' },
      { max: 0.36, grade: 'V3' }, { max: 0.59, grade: 'V4' }, { max: 0.61, grade: 'V5' },
      { max: 0.63, grade: 'V6' }, { max: 0.81, grade: 'V7' }, { max: 0.91, grade: 'V8' },
      { max: 1.00, grade: 'V9' }, { max: 1.04, grade: 'V10' }, { max: 1.08, grade: 'V11' },
      { max: 1.23, grade: 'V12' }, { max: 1.38, grade: 'V13' }, { max: 1.52, grade: 'V14' },
      { max: 1.55, grade: 'V15' }, { max: Infinity, grade: 'V16' }
    ];
    var LB_TO_KG = 0.453592;
    var SAMPLE_INDEX = 6; // the sample result is V6
    var WAIT = 600;

    var bwEl = document.getElementById('zc-bw');
    var maxEl = document.getElementById('zc-max');
    var resultEl = document.getElementById('zc-result');
    var sampleEl = document.getElementById('ztt-sample');
    var gradeEl = document.getElementById('zc-grade');
    var ratioEl = document.getElementById('zc-ratio');
    var nextEl = document.getElementById('ztt-nextline');
    var carrotEl = document.getElementById('ztt-carrot');
    var nextLabelEl = document.getElementById('ztt-next-label');
    var addEl = document.getElementById('ztt-add');
    var totalEl = document.getElementById('ztt-total');
    var fbEl = document.getElementById('zc-fb');
    var fbMarkup = fbEl ? fbEl.innerHTML : '';
    var ruler = root.querySelector('[data-ztt-ladder]');
    var nums = ruler ? ruler.querySelectorAll('.ztt-ruler__nums span') : [];
    var youEl = root.querySelector('[data-ztt-you]');
    var nextTagEl = root.querySelector('[data-ztt-next-tag]');
    var unitLabels = root.querySelectorAll('[data-ztt-unit]');
    var endpoint = root.dataset.endpoint || '';
    var lastSent = null;
    var lastFeedback = null;
    var pending = null;

    function unit() {
      var picked = root.querySelector('input[name="zc-unit"]:checked');
      return picked ? picked.value : 'lbs';
    }
    function indexFor(ratio) {
      for (var i = 0; i < BANDS.length; i++) { if (ratio < BANDS[i].max) return i; }
      return BANDS.length - 1;
    }
    // The ruler: fill and flag at gi, and the next grade's cost on the dashed line.
    function ladder(gi, add) {
      if (!ruler) return;
      var top = gi >= BANDS.length - 1;
      ruler.style.setProperty('--gi', gi);
      ruler.classList.toggle('is-start', gi <= 1);
      ruler.classList.toggle('is-end', gi >= 15);
      ruler.classList.toggle('is-late', gi >= 11);
      ruler.classList.toggle('is-top', top);
      for (var i = 0; i < nums.length; i++) nums[i].classList.toggle('is-have', i <= gi);
      youEl.textContent = BANDS[gi].grade;
      if (!top) nextTagEl.textContent = BANDS[gi + 1].grade + ' · ' + add;
      ruler.setAttribute('aria-label', 'Grade scale from V0 to V16, your fingers at ' + BANDS[gi].grade +
        (top ? ', the top of the scale' : ', ' + BANDS[gi + 1].grade + ' is ' + add.replace('+', '') + ' away'));
    }
    function showSample() {
      resultEl.hidden = true;
      sampleEl.hidden = false;
      if (fbEl) fbEl.hidden = true;
      ladder(SAMPLE_INDEX, '+2 lbs');
    }

    function calculate() {
      pending = null;
      var u = unit();
      for (var l = 0; l < unitLabels.length; l++) unitLabels[l].textContent = u;
      var bw = parseFloat(bwEl.value);
      var mx = parseFloat(maxEl.value);
      if (!(bw > 0) || !(mx > 0)) { showSample(); return; }

      var ratio = mx / bw;
      var gi = indexFor(ratio);
      var kg = u === 'lbs' ? LB_TO_KG : 1;

      // posthog.js reads these (in kg) when #zc-grade changes, so set them first.
      root.dataset.bw = (bw * kg).toString();
      root.dataset.max = (mx * kg).toString();
      root.dataset.grade = BANDS[gi].grade;

      ratioEl.textContent = 'Ratio ' + ratio.toFixed(2) + '×';
      if (gi < BANDS.length - 1) {
        var next = BANDS[gi].max;
        nextEl.textContent = BANDS[gi + 1].grade + ' starts at a ' + next.toFixed(2) + '× ratio.';
        nextLabelEl.textContent = 'To add for ' + BANDS[gi + 1].grade;
        var add = '+' + Math.round(next * bw - mx) + ' ' + u;
        addEl.textContent = add;
        totalEl.textContent = Math.round(next * bw) + ' ' + u + ' total lift';
        carrotEl.hidden = false;
      } else {
        nextEl.textContent = 'Top of the scale.';
        carrotEl.hidden = true;
      }
      ladder(gi, add);

      sampleEl.hidden = true;
      resultEl.hidden = false;
      gradeEl.textContent = BANDS[gi].grade;

      if (fbEl) {
        if (lastSent !== null) fbEl.innerHTML = fbMarkup;
        fbEl.hidden = false;
      }
      lastSent = null;
    }

    function schedule() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(calculate, WAIT);
    }

    function sendFeedback(vote) {
      if (lastSent === vote) return;
      lastSent = vote;
      var accurate = vote === true;
      var u = unit();
      var kg = u === 'lbs' ? LB_TO_KG : 1;
      var bwEntered = parseFloat(bwEl.value);
      var maxEntered = parseFloat(maxEl.value);
      var bwKg = parseFloat(root.dataset.bw);
      var maxKg = parseFloat(root.dataset.max);
      if (!isFinite(bwKg) && isFinite(bwEntered)) bwKg = bwEntered * kg;
      if (!isFinite(maxKg) && isFinite(maxEntered)) maxKg = maxEntered * kg;
      var ratio = bwKg > 0 && isFinite(maxKg) ? Math.round((maxKg / bwKg) * 100) / 100 : null;
      var props = {
        calculator: 'finger-strength',
        accurate: accurate,
        vote: accurate ? 'yes' : 'no',
        grade: root.dataset.grade || gradeEl.textContent || '',
        ratio: ratio,
        unit: u,
        bw: isFinite(bwEntered) ? bwEntered : null,
        max_lift: isFinite(maxEntered) ? maxEntered : null,
        bw_kg: isFinite(bwKg) ? Math.round(bwKg) : null,
        max_kg: isFinite(maxKg) ? Math.round(maxKg) : null
      };
      lastFeedback = props;
      if (window.zodiacPosthog) window.zodiacPosthog.capture('Calculator Feedback', props);
      else if (window.posthog) window.posthog.capture('Calculator Feedback', props);
      if (endpoint) {
        var body = new URLSearchParams();
        body.append('bodyWeight', root.dataset.bw || '');
        body.append('maxWeight', root.dataset.max || '');
        body.append('grade', root.dataset.grade || '');
        body.append('isThumbsUp', accurate ? 'true' : 'false');
        body.append('timestamp', new Date().toISOString());
        fetch(endpoint, { method: 'POST', mode: 'no-cors', body: body }).catch(function () {});
      }
      if (accurate) fbEl.innerHTML = '<p class="ztt-fb__thanks">Thanks, this helps our dataset.</p>';
      else askClimb();
    }

    // A "no" alone can't say whether the grade read high or low, so ask once.
    function askClimb() {
      var opts = '<option value="">Pick a grade</option>';
      for (var i = 0; i < BANDS.length; i++) opts += '<option value="' + i + '">' + BANDS[i].grade + '</option>';
      fbEl.innerHTML = '<label class="ztt-k" for="zc-climb">What do you climb? (optional)</label>' +
        '<select class="ztt-fb__climb" id="zc-climb">' + opts + '</select>';
    }

    function sendClimb(select) {
      var ci = parseInt(select.value, 10);
      if (isNaN(ci)) return;
      var grade = root.dataset.grade || gradeEl.textContent || '';
      var gi = -1;
      for (var i = 0; i < BANDS.length; i++) { if (BANDS[i].grade === grade) gi = i; }
      var props = {
        calculator: 'finger-strength',
        grade: grade,
        climbs: BANDS[ci].grade,
        grade_gap: gi < 0 ? null : gi - ci,
        reads: gi < 0 ? null : (gi > ci ? 'high' : gi < ci ? 'low' : 'match'),
        ratio: lastFeedback ? lastFeedback.ratio : null,
        bw_kg: lastFeedback ? lastFeedback.bw_kg : null,
        max_kg: lastFeedback ? lastFeedback.max_kg : null
      };
      if (window.zodiacPosthog) window.zodiacPosthog.capture('Calculator Grade Reported', props);
      else if (window.posthog) window.posthog.capture('Calculator Grade Reported', props);
      fbEl.innerHTML = '<p class="ztt-fb__thanks">Thanks, this helps our dataset.</p>';
    }

    [bwEl, maxEl].forEach(function (el) {
      el.addEventListener('input', schedule);
      el.addEventListener('change', calculate);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); calculate(); }
      });
    });
    root.querySelectorAll('input[name="zc-unit"]').forEach(function (r) {
      r.addEventListener('change', calculate);
    });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.z-calc__thumb');
      if (btn) sendFeedback(btn.dataset.vote === '1');
    });
    root.addEventListener('change', function (e) {
      if (e.target.id === 'zc-climb') sendClimb(e.target);
    });

    // A browser that restores the fields on back/forward gets a real result.
    if (bwEl.value || maxEl.value) calculate();
  })();
})();
